import script from "./HistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./HistoryModal.vue?vue&type=style&index=0&id=a23a4540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a23a4540"]])

export default __exports__